<template>
  <div class="dingWorkbench">
    <user-info></user-info>
    <!-- 轮播 -->
    <!-- <div class="ding-carousel" @click="carouselClick()"> -->
    <div class="ding-carousel" >
      <!-- <el-carousel ref="carousel" height="150px">
        <el-carousel-item v-for="item in 1" :key="item">
          <img src="http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/banner%402x.png.jpg" alt="">
        </el-carousel-item>
      </el-carousel> -->
      <div @click="carousel">
        <img style="height:150px;border-radius: 5px;" src="http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/banner%402x.png.jpg" alt="">
      </div>
    </div>
    <!-- 卡片 -->
    <div class="ding-card-cont">
      <ul>
        <li @click="toPath('./protocol', 1, '复星集团战略协议')">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card1.png" alt="">
          <p class="tit">复星集团战略协议</p>
          <p>Fosun Group Strategic Agreement</p>
        </li>
        <li @click="toFosunSupplier()">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card2.png" alt="">
          <p class="tit">复星供应商库</p>
          <p>Fosun Suppliers</p>
        </li>
        <li @click="openCz()">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card3.png" alt="">
          <p class="tit">采招项目</p>
          <p>Procurement Bidding Project</p>
        </li>
        <li @click="toPathDingBiMobile('./dingBiMobile')">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card4.png" alt="">
          <p class="tit">BI数据看板</p>
          <p>BI Dashboard</p>
        </li>
        <li class="card-li-pd" @click="toPath('./dingSupplyChain', 1, '采购供应链数智化平台')">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card5.png" alt="">
          <p class="tit">采购供应链<br/>数智化平台</p>
          <p>Digital Supply Chain</p>
        </li>
        <li @click="toRisk">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/card6.png" alt="">
          <p class="tit">风控中心</p>
          <p>Risk Control Center</p>
        </li>
      </ul>
    </div>
    <!-- 采购共享服务 -->
    <div class="ding-server-cont">
      <div class="ding-server-tit">采购共享服务</div>
      <ul>
        <li @click="toPath('./regimeList', 2, '规章制度')">
          <div class="server-img-cont">
            <img class="img4" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/zd_icon.svg" alt="">
          </div>
          <p class="tit">规章制度</p>
          <p>Procurement Policies</p>
        </li>
        <li @click="toPath('./creditReport', 2, '安心采')">
          <div class="server-img-cont">
            <img class="img3" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/axc_icon.svg" alt="">
          </div>
          <p class="tit">安心采</p>
          <p>Procurement Ensurance</p>
        </li>
        <li @click="toPath('./dingOverseas', 2, '采购寻源海外版')">
          <div class="server-img-cont">
            <img class="img3" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/hw_icon.svg" alt="">
          </div>
          <p class="tit">采购寻源<br/>海外版</p>
          <p>eRFQ</p>
        </li>
        <li @click="toDingServer()">
          <div class="server-img-cont">
            <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/zx_icon.svg" alt="">
          </div>
          <p class="tit">采购咨询</p>
          <p>Procurement Consultation</p>
        </li>
        <li @click="openPhone()">
          <div class="server-img-cont">
            <img class="img2" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/sj_icon.svg" alt="">
          </div>
          <p class="tit">客服热线</p>
          <p>Service Hotline</p>
        </li>
        <li @click="openGzh()">
          <div class="server-img-cont">
            <img class="img5" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/wx_icon.svg" alt="">
          </div>
          <p class="tit">公众号</p>
          <p>Wechat Official Accounts</p>
        </li>
      </ul>
    </div>

    <el-dialog
      title=""
      :visible.sync="gzhDialog"
      width="80%"
      class="qrcode-dialog"
      :show-close="false"
      :before-close="handleClose">
      <div class="qrcode-img-cont">
        <img class="qrcode-img" src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/QRcode.png" alt="">
        <div class="qrcode-hint">请长按二维码保存至本地，在微信端扫码关注</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="supplyDailog = false">取 消</el-button> -->
        <span @click="gzhDialog = false">知道了</span>
      </span>
    </el-dialog>
<!--
    <el-dialog
      title=""
      :visible.sync="phoneDialog"
      width="80%"
      class="ding-phone-dialog"
      :show-close="false"
      :before-close="phoneHandleClose">
      <div class="phone-body-cont">
        <div class="phone-body-item1">客服热线</div>
        <div class="phone-body-item2">0516-87796393</div>
      </div>
      <div slot="footer" class="dialog-footer phone-dialog-footer">
        <div class="phone-btn-left" @click="phoneDialog = false">取消</div>
        <div class="phone-btn-right" @click="callPhone()">拔打</div>
      </div>
    </el-dialog> -->
    <el-dialog
      title=""
      :visible.sync="phoneDialog"
      width="94%"
      class="ding-phone-dialog"
      :show-close="false"
      :before-close="phoneHandleClose">
      <div class="phone-body-cont">
        <div class="phone-item-cont">
          <div class="phone-item-left">
            <div class="phone-img-cont">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_phone.svg" alt=""/>
            </div>
          </div>
          <div class="phone-item-right">
            <div class="phone-body-item1">客服热线</div>
            <div class="phone-body-item2" @click="callPhone()">0516-87796393</div>
            <div class="phone-body-item3">工作时间：工作日 08:30-17:00</div>
          </div>
        </div>
        <div class="phone-item-cont">
          <div class="phone-item-left">
            <div class="phone-img-cont">
              <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/dding/icons_envelope.svg" alt=""/>
            </div>
          </div>
          <div class="phone-item-right" @click="copy('exonelink@wbpharma.com')">
            <div class="phone-body-item1">客服邮箱</div>
            <div class="phone-body-item3">exonelink@wbpharma.com</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer phone-dialog-footer">
        <div class="phone-btn-left" @click="phoneDialog = false">取消</div>
        <!-- <div class="phone-btn-right" @click="callPhone()">拔打</div> -->
      </div>
    </el-dialog>

    <div v-show="toastShow" class="toast-cont" :class="toastShow?'toast-cont-active':''">
      <!-- <div class="toast-mask"></div> -->
      <i v-if="toastType=='success'" class="el-icon-success"></i>
      <i v-if="toastType=='warning'" class="el-icon-warning"></i>
      <div v-if="toastType=='success'" class="tost-icon-txt">{{successMsg||'提交成功'}}</div>
      <div v-if="toastType=='warning'" class="tost-icon-txt">{{errorMsg||'请先完善申请信息'}}</div>
    </div>
    <toopbar></toopbar>
  </div>
</template>
<script>
  import {toCzItem,toFosunSupplierUrl} from '@/assets/js/utils'
  import {handleClipboard} from '@/assets/js/clipboard';
  import toopbar from './components/toopbar.vue'
  import userInfo from './components/userInfo.vue'
  import * as customSensors from '@/assets/js/sensors'

  export default {
    props: [],
    data () {

      return {
        gzhDialog:false,
        phoneDialog:false,
        timer:null,
        toastType:'',
        toastShow:false,
        timer:null,
        errorMsg:'',
        successMsg:''
      }
    },
    components: {
      "toopbar":toopbar,
      "user-info":userInfo
    },
    created () {
      // this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      // }).then((res) => {
      //   this.data = res.data;
      //   this.webConfigInfo = this.data.webConfigInfoDto;
      //   this.footerColumnInfos = this.data.footerColumnInfos;
      //   this.navigationColumnInfos = this.data.navigationColumnInfos;
      //   this.yellowPageColumn = this.data.yellowPageColumn;
      //   this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      //   this.hitSearchUrl = this.data.hitSearchUrl;
      //   this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      // }).catch((err) => {
      //   console.log(err)
      // })
    },
    mounted () {
      setTimeout(()=>{

        document.title="一链网"

      },2000)
      fosun_oapi_login.getDDAccount(function(user = {}){
        customSensors.customHomePageView({
          user_name: user.fullname,
          user_email: user.email
        })
      });
    },
    methods: {
      toRisk () {
        try{
          customSensors.customModuleClick({
            module_type: '系统板块',
            module_name: '风控中心'
          })
        } catch (e) {}
        let url=window.location.href
        let evn = (/local.onelinkplus.com/.test(url) || /test/.test(url) ? "test-" : /uat/.test(url) ? "uat-" : "");
        window.location.href=`http://${evn}mdata-bi-mobile.onelinkplus.com/#/Risk`;
      },
      carousel () {
        customSensors.customOperationClick({
          page_title: "钉钉工作台首页",
          operation_type: `钉钉首页轮播图`
        })
      },
      // 解决elementui在移动端点击停止轮播问题
      carouselClick(){
        // console.info(this.$refs.carousel)
          clearTimeout(this.timer)
        this.timer=setTimeout(()=>{
          this.$refs.carousel.startTimer()
          // this.$refs.carousel.hover=false
          clearTimeout(this.timer)
        },5000)
        window.location.href=`${window.location.origin}`
      },
      openCz(){
        try{
          customSensors.customModuleClick({
            module_type: '系统板块',
            module_name: '采招项目'
          })
        } catch (e) {}
        toCzItem()
      },
      openGzh(){
        this.gzhDialog=true
        try{
          customSensors.customModuleClick({
            module_type: '服务板块',
            module_name: '公众号'
          })
        } catch (e) {}
      },
      openPhone(){
        this.phoneDialog=true
        try{
          customSensors.customModuleClick({
            module_type: '服务板块',
            module_name: '客服热线'
          })
        } catch (e) {}
      },
      callPhone(){
        window.location.href = "tel:0516-87796393";
        this.phoneDialog=false
      },
      handleClose(){
        this.gzhDialog=false
      },
      phoneHandleClose(){
        this.phoneDialog=false
      },
      toPath(url, type, name){
        try{
          customSensors.customModuleClick({
            module_type: type == 1 ? '系统板块' : '服务板块',
            module_name: name
          })
        } catch (e) {}
        this.$router.push({path:url})
      },
      toDingServer(){

        // loadScript('https://oapi.fosun.com/m/js/fosun_oapi_login-2.0.0_v2.js',() => {
        //   loadScript('http://o.fosun.com/mobile_portal/fosun/server/return.js',() => {
        //     try {

        //       dd.ready(function () {
        //         dd.biz.util.open({
        //           name: "chat",
        //           params: {

        //             corpId: 'ding7a05491d2e914134', //企业ID
        //             users: ["18217554023",'13918033483','15821968343','13816816859','13795450265',
        //                     '18918596157','13918961292','13636662459','13774492991','13564717626','18817354480',
        //                     '18201733235','18017080892','13585683953','13262537126','13621966237','13701701601',
        //                     '18512137679','18516692150','15021059479','15021027945','13918412287','13501731646',
        //                     '18721918361','13661410909','18616929759','15921906335','13818561222','18217325635'] //共享热线客服

        //           },
        //           onFail: function (error) {
        //             alert(JSON.stringify(error))
        //           }
        //         });

        //       })
        //     } catch (e) {
        //       throw e
        //     }
        //   });
        // });
        try{
          customSensors.customModuleClick({
            module_type: '服务板块',
            module_name: '采购咨询'
          })
        } catch (e) {}
        window.open(`dingtalk://dingtalkclient/action/sendmsg?spm=a1z2e.8089787.content.dingtalk.7c364f9bXj6c9i&dingtalk_id=80z_mkk6zlffo`,'_blank')
      },
      toPathDingBiMobile(url){
        this.$axios
        .get("/onelink.mdata.bi.api/dingDing/workbench/getFunctionList")
        .then((res) => {
          if (res.data.code === 0) {
            this.$router.push({path:url})
          } else if (res.data.code == 10000005) {
            this.$router.push({
              path: "/login",
              query: { redirectURL: window.location.href },
            });
          } else if (res.data.code == 10000009) {
            this.$router.push({
              path: "/noAccess"
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.errorMsg,
            });
          }
        }).finally(() => {
          try{
            customSensors.customModuleClick({
              module_type: '系统板块',
              module_name: 'BI数据看板'
            })
          } catch (e) {}
        })
      },
      toFosunSupplier(){
        try{
          customSensors.customModuleClick({
            module_type: '系统板块',
            module_name: '复星供应商库'
          })
        } catch (e) {}
        toFosunSupplierUrl()
      },
      copy(text) {
          handleClipboard(text, event, () => {
            this.phoneDialog=false
            this.successMsg='客服邮箱已复制到剪贴板'
            this.toastType='success'
            this.toastShow=true
            this.timer=setTimeout(()=>{
              this.toastShow=false
              clearTimeout(this.timer)
            },3000)
          }, () => {
            this.phoneDialog=false
            this.successMsg='单号复制失败！'
            this.toastType='success'
            this.toastShow=true
            this.timer=setTimeout(()=>{
              this.toastShow=false
              clearTimeout(this.timer)
            },3000)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/dingWorkbench/index.vue